import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../utils/translations';
import {MESSAGE__24} from '@homeaway/svg-defs/lib/defs/MESSAGE__24';
import {PHONE__24} from '@homeaway/svg-defs/lib/defs/PHONE__24';
import {ButtonIcon} from '@homeaway/react-buttons';
import {IpmHostInfo} from '../IpmHostInfo/IpmHostInfo';
import {Link as LocalizedLink} from '@homeaway/react-localization-components';

import './PropertyContactMobile.less';

export class PropertyContactMobile extends React.Component {
    static propTypes = {
        avatar: PropTypes.string,
        backUrl: PropTypes.string,
        conversationId: PropTypes.string.isRequired,
        ownerName: PropTypes.string,
        phone: PropTypes.string,
        showSendMessageBtn: PropTypes.bool,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        backUrl: '/traveler/th/inbox',
        translations: {},
    };

    render() {
        const {
            avatar,
            conversationId,
            ownerName,
            phone,
            showSendMessageBtn,
            translations,
        } = this.props;

        if (!avatar && !ownerName && !phone && !showSendMessageBtn) {
            return null;
        }

        return (
            <>
                <div className="PropertyContactMobile">
                    {avatar && (
                        <div
                            className="PropertyContactMobile__image img-circle"
                            style={{backgroundImage: `url(${avatar})`}}
                        />
                    )}
                    <div className="PropertyContactMobile__name-container">
                        <small>
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.details.propertyContact'
                            )}
                        </small>
                        {ownerName && (
                            <div className="property-contact-name">
                                {ownerName}
                            </div>
                        )}
                    </div>
                    <div className="PropertyContactMobile__buttons">
                        {phone && (
                            <ButtonIcon
                                circle
                                href={`tel:${phone}`}
                                label={translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.inbox.conversation.buttons.phone'
                                )}
                                svgMarkup={PHONE__24}
                                className="PropertyContactMobile__callAction"
                            />
                        )}
                        {showSendMessageBtn && (
                            <LocalizedLink
                                data-testid="localisedlink"
                                href={`/traveler/th/inbox/conversation/${conversationId}/messages`}
                                className={'PropertyContactMobile__button'}
                            >
                                <ButtonIcon
                                    circle
                                    label={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.inbox.conversation.buttons.messages'
                                    )}
                                    svgMarkup={MESSAGE__24}
                                />
                            </LocalizedLink>
                        )}
                    </div>
                </div>
                <IpmHostInfo translations={translations} />
            </>
        );
    }
}
